import { InputAdornment, Tooltip, makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import EditClient from "../../icons/EditClient";
import { Field } from "formik";
import FMUInputField from "../shared/FormIkMUFormComponent/FMUInputField";
import { tokens } from "../../theme/tokens";

const useStyle = makeStyles((theme) => ({
  caseContainer: {
    // width: "928px",
    width: "98%",
    paddingLeft: "2%",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  topBar: {
    height: "50px",

    padding: "0 2% 0 2%",
    display: "flex",
    alignItems: "center",
  },
  heading: {
    fontSize: "1em",
    color: tokens.color.brand.primaryAction,
    //fontWeight: "bold",
  },
  parent: {
    justifyContent: "space-between",
    flexDirection: "row",
    flexWrap: "wrap",
    display: "flex",
    paddingRight: "2%",
    marginTop: "2vh",
  },
  parentChild: {
    flex: "1",
    width: "40%",
    "&:nth-child(1)": {
      paddingRight: "5vh",
    },
    "&:nth-child(2)": {
      paddingLeft: "5vh",
    },
  },
  rowContainer: {
    display: "flex",
    marginTop: "8px",
  },
  labelContainer: {
    display: "flex",
    width: "50%",
    alignItems: "center",
    "& p": {
      fontSize: "1em",
      // fontWeight:"bold",
      color: tokens.color.text.primary,
    },
  },
  fieldContainer: {
    width: "50%",
  },

  input: {
    // width: "95%",
    border: `1px solid ${tokens.color.border.default}`,
    "& .MuiInputBase-input": {
      textIndent: "10px",
    },
    borderRadius: tokens.radius.sm,
    height: "40px",
    paddingLeft: "3px",
    backgroundColor: tokens.color.surface.sunken,
  },
  subjectButton: {
    // padding:"0.5vh 3vh 0.5vh 3vh",
    width: "160px",
    color: tokens.color.brand.onPrimary,
    //fontWeight: "bold",
    textTransform: "capitalize",
    backgroundColor: tokens.color.brand.primaryAction,
    // border: "1px solid #3C72D9",
    borderRadius: tokens.radius.sm,
    fontSize: "1.1em",
    "&:hover": {
      backgroundColor: tokens.color.brand.primaryAction,
      opacity: "0.8",
    },
  },
  buttonRow: {
    display: "flex",
    flexDirection: "row-reverse",
    columnGap: "15px",
    marginTop: "1vh",
  },
  buttonRowTabButton: {
    boxShadow: "none",
    backgroundColor: tokens.color.surface.sunken,
    borderRadius: tokens.radius.sm,
    textTransform: "capitalize",
  },

  invoiceBreakdownTable: {
    width: "100%",
    textAlign: "left",
    color: tokens.color.text.primary,
    borderCollapse: "separate",
    borderSpacing: "0 0px",
    fontSize: "1em",
    // maxWidth:"fit-content",
    // overflow: "visible",
    // display: "block",
    // overflowX: "auto",
    whiteSpace: "nowrap",
  },
  headerStyle: {
    height: "40px",
  },
  rowHeaderStyle: {
    fontSize: "0.9em",
    fontWeight: 600,
    color: tokens.color.text.secondary,
    paddingLeft: "5px",
    height: "40px",
    border: `1px solid ${tokens.color.border.default}`,
    borderRight: "0px !important",
    borderTop: "0px",
    "&:first-child": {
      borderLeft: "0px !important",
    },
  },
  tableTd: {
    paddingLeft: "30px",
    whiteSpace: "nowrap",
    border: `1px solid ${tokens.color.border.default}`,
    borderRight: "0px !important",
    borderTop: "0px",
    "&:first-child": {
      borderLeft: "0px !important",
    },
    "&:last-child": {
      borderRight: "0px !important",
    },
    "&:hover": {
      backgroundColor: tokens.color.surface.sunken,
    },
  },
  tableTh: {
    fontSize: "0.9em",
    fontWeight: 600,
    color: tokens.color.text.secondary,
    textAlign: "left",
    backgroundColor: tokens.color.surface.sunken,
    paddingLeft: "10px",
    whiteSpace: "pre-line !important",
    wordWrap: "break-word",

    border: `1px solid ${tokens.color.border.default}`,
    borderRight: "0px",

    "&:last-child": {
      borderRight: `1px solid ${tokens.color.border.default}`,
      borderTopRightRadius: tokens.radius.sm,
      borderBottomRightRadius: tokens.radius.sm,
    },
  },
  tableThEmpty: {
    fontSize: "0.9em",
    backgroundColor: tokens.color.surface.sunken,
    width: "10px",
    border: `1px solid ${tokens.color.border.default}`,
    borderRight: "0px",
    "&:first-child": {
      borderTopLeftRadius: tokens.radius.sm,
      borderBottomLeftRadius: tokens.radius.sm,
    },
  },
  wrap: {
    // whiteSpace: "nowrap"
  },
  actionButton: {
    backgroundColor: theme.palette.primary.main,
    // fontFamily: "poppins",
    //fontWeight: "bold",
    fontSize: ".8em",
    color: tokens.color.brand.onPrimary,
    textTransform: "inherit",
    borderRadius: tokens.radius.full,
    boxShadow: "none",
    textAlign: "center",
    marginRight: "2%",
    border: `1px solid ${tokens.color.brand.primary}`,
    // height: "15px",
    padding: "8px",

    // border: "1px solid #3C72D9",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      opacity: "0.8",
    },
    "&.Mui-disabled": {
      backgroundColor: tokens.color.surface.subtle,
      color: tokens.color.brand.onPrimary,
    },
  },
  formikInput: {
    color: theme.palette.primary.main,
    fontSize: "1em",
    // marginLeft: "1vh",
    // width: "50%",
    textAlign: "right",
    "& .MuiInputBase-input": {
      textAlign: "right",
    },
    "& ::-webkit-calendar-picker-indicator": {
      marginLeft: "0px",
    },
  },
  quantAndRate: {
    color: tokens.color.text.primary,
  },
}));

function InvoiceBreakdownTable({ index, values, setFieldValue }) {
  const classes = useStyle();

  // Extracting the keys for column headers
  const columnTitles = [
    { name: "Staff Investigator Hours", key: "staff_investigator_hours" },
    { name: "Field Investigator Hours", key: "field_investigator_hours" },
    { name: "Database Searches", key: "database_searches_hours" },
    {
      name: "Field Investigator Database Searches",
      key: "field_investigator_database_searches_hours",
    },
    {
      name: "Field Investigator Mileage",
      key: "field_investigator_mileage_hours",
    },
  ];
  const rowTitles = [
    { name: "Quantity", key: "quantity" },
    { name: "Rate", key: "rate" },
    { name: "Amount", key: "amount" },
  ];

  return (
    <table className={classes.invoiceBreakdownTable}>
      <thead>
        <tr className={classes.headerStyle}>
          <th className={classes.tableThEmpty}></th>
          {columnTitles.map((title, index) => (
            <th key={index} className={classes.tableTh}>
              {title.name}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rowTitles.map((rowTitle, rowIndex) => (
          <tr key={rowIndex} style={{ fontSize: "1em", color: tokens.color.text.primary }}>
            <th className={classes.rowHeaderStyle}>{rowTitle.name}</th>
            {columnTitles.map((columnTitle, colIndex) => (
              <td key={colIndex} className={classes.tableTd}>
                {rowTitle?.key == "amount" ? (
                  <span
                    className={`${classes.formikInput}`}
                    style={{
                      justifyContent: "end",
                      display: "flex",
                      paddingRight: "14px",
                    }}
                  >
                    {"$" +
                      (
                        values.invoices[index]?.invoice_breakdown[
                          columnTitle.key
                        ]?.quantity *
                        values.invoices[index]?.invoice_breakdown[
                          columnTitle.key
                        ]?.rate
                      ).toFixed(2)}
                  </span>
                ) : (
                  <>
                    <Field
                      name={`invoices[${index}].invoice_breakdown[${columnTitle.key}][${rowTitle.key}]`}
                      type={"number"}
                      className={`${classes.formikInput} ${classes.quantAndRate}`}
                      disableUnderline={true}
                      component={FMUInputField}
                      value={
                        values.invoices[index].invoice_breakdown[
                          columnTitle.key
                        ][rowTitle.key]
                      }
                      onChange={(e) => {
                        var tempAmount =
                          values.invoices[index].invoice_breakdown[
                            columnTitle.key
                          ]["quantity"] *
                          values.invoices[index].invoice_breakdown[
                            columnTitle.key
                          ]["rate"];
                        setFieldValue(
                          `invoices[${index}].invoice_breakdown[${columnTitle.key}].[${rowTitle.key}]`,
                          parseFloat(e.target.value),
                        );
                      }}
                    />
                  </>
                )}

                {/* {invoice_breakdown[columnTitle.key][rowTitle.key]} */}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default InvoiceBreakdownTable;
